import $ from 'jquery';
import { pageLanguage } from '../util/common';
import InfoBox from './map/infobox';
import MarkerClusterer from './map/markerclusterer';
import GoogleMapsLoader from 'google-maps';

import Swiper from 'swiper/dist/js/swiper.min'

let google;

function placeRandomMarkers(map)
{
  return plotRandom(map, 100);
}


function plotRandom(map, number)
{
  let bounds = map.getBounds();

  window.console.log('bounds', bounds); 

  let southWest = bounds.getSouthWest();
  let northEast = bounds.getNorthEast();
  let lngSpan = northEast.lng() - southWest.lng();
  let latSpan = northEast.lat() - southWest.lat();

  let pointsrand = [];

  for (let i = 0; i < number; ++i)
  {
    var point = new google.maps.LatLng(southWest.lat() + latSpan * Math.random(), southWest.lng() + lngSpan * Math.random());

    pointsrand.push(point);
  }

  let markers = [];

  for (let i = 0; i < number; ++i)
  {
    window.console.log('placeMarker', i + ': ' + pointsrand[i]);
    var marker = placeMarker(map, pointsrand[i], i + ': ' + pointsrand[i]);

    markers.push(marker);
  }

  return markers;
}


function placeMarker(map, latlng, title)
{
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    title: title,
  });

  return marker;
}

class HFMap {

  constructor(id, options) {
    GoogleMapsLoader.KEY = 'AIzaSyCx_YuXNQRJJbXhe-cfwPJKNIXjHrQS3wk';
    GoogleMapsLoader.LANGUAGE = pageLanguage();
    GoogleMapsLoader.load((g) => {

      google = g;

      this.options = {
        iconSize: new google.maps.Size(28, 35),

        mapConfig: {
            center: { // milan
                lat: 45.4773,
                lng: 9.1815,
            },
            // center: {lat: 41.876, lng: -87.624},
            zoom: 11,
            // minZoom: 9,
            // maxZoom: 18,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            scrollwheel: false,
        },
        clusterer: {
          minimumClusterSize: 1,
          maxZoom: 13, // livello massimo di visibilità dei cluster
        },
        infoBox: {
          closeOnMapClick: true,
          closeOnMapZoomChanged: true,
        },
        filters: false,
        kmlLayer: false,
        // strictBounds: new google.maps.LatLngBounds(
        //     new google.maps.LatLng(36.5, 12.0),
        //     new google.maps.LatLng(38.7, 15.7)
        // ),
        strokeOpacity: 0.7,
        strokeWeight: 6,
        translations: {
          sell: 'Vendita',
          rent: 'Affitto',
          rooms: 'Locali',
          surface: 'Superficie',
          bathrooms: 'Bagni',
          floor: 'Piano',
        }
      }

      $.extend(this.options, options);

      $.extend(this.options.mapConfig, {
        styles: [
          {
            'featureType': 'poi',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
        ],
      });

      this.markers = [];

      // console.log(id, this.options);
  
      this.map = new google.maps.Map(document.getElementById(id), this.options.mapConfig);

      if(this.options.infoBox) {
        this.map.infoBox = new InfoBox({
          alignBottom: true,
          pixelOffset: {
            width: 0,
            height: -40,
          },
          infoBoxClearance: {
            width: 15,
            height: 15,
          }
        });
      }

      if(this.options.kmlLayer) {
        var ctaLayer = new google.maps.KmlLayer({
          url: this.options.kmlLayer,
          map: this.map
        });
        // var ctaLayer = new google.maps.KmlLayer(this.options.kmlLayer, {
        //   suppressInfoWindows: true,
        //   preserveViewport: false,
        //   map: this.map
        // });
        // ctaLayer.addListener('click', function(event) {
        //   var content = event.featureData.infoWindowHtml;
        //   var testimonial = document.getElementById('capture');
        //   testimonial.innerHTML = content;
        // });
      }
    
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        setTimeout(() => {
          if(!this.options.markers) {
            this.markers = placeRandomMarkers(this.map);
          } else {
            this.placeMarkers();
          }

          if(this.options.clusterer) {
            this.clusterer = new MarkerClusterer(this.map, this.markers, {
              minimumClusterSize: this.options.clusterer.minimumClusterSize,
              maxZoom: this.options.clusterer.maxZoom,
              imagePath: '/app/themes/bryan/dist/images/map/clusters/m',
              imageExtension: 'svg'
            });
          }

          if(!!this.options.filters) {
            this.addFilters();
          }
        }, 200);
      });

      if(this.options.infoBox && this.options.infoBox.closeOnMapClick) {
        this.map.addListener('click', () => {
          this.map.infoBox.close();
        });
      }

      if(this.options.infoBox && this.options.infoBox.closeOnMapZoomChanged) {
        this.map.addListener('zoom_changed', () => {
          this.map.infoBox.close();
        });
      }
    });

  }

  addFilters() {
    this.filter = '';
    var styles = {
      normal: {
        color: 'rgb(70, 70, 70)',
        backgroundColor: 'rgb(255, 255, 255)',
        fontWeight: 400
      },
      hover: {
        color: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(245,245,245)'
      },
      selected: {
        color: 'rgb(255,255,255)',
        backgroundColor: '#124f8a',
        fontWeight: 400
      }
    }

    var toSellControlDiv = document.createElement('div');

    toSellControlDiv.style.margin = '10px 0 0 10px';

    var toSellControlUI = document.createElement('div');

    toSellControlUI.style.cursor = 'pointer';
    toSellControlUI.style.direction = 'ltr';
    toSellControlUI.style.overflow = 'hidden';
    toSellControlUI.style.textAlign = 'center';
    toSellControlUI.style.height = '40px';
    toSellControlUI.style.display = 'table-cell';
    toSellControlUI.style.verticalAlign = 'middle';
    toSellControlUI.style.position = 'relative';
    toSellControlUI.style.color = styles.normal.color;
    toSellControlUI.style.fontFamily = 'Roboto, Arial, sans-serif';
    toSellControlUI.style.fontWeight = styles.normal.fontWeight;
    toSellControlUI.style.userSelect = 'none';
    toSellControlUI.style.fontSize = '15px';
    toSellControlUI.style.textTransform = 'uppercase';
    toSellControlUI.style.backgroundColor = styles.normal.backgroundColor;
    toSellControlUI.style.padding = '0px 17px';
    toSellControlUI.style.borderRadius = '2px 0 0 2px';
    toSellControlUI.style.backgroundClip = 'padding-box';
    toSellControlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
    toSellControlUI.style.minWidth = '66px';
    toSellControlUI.style.borderLeft = '0px';

    toSellControlUI.title = typeof this.options.translations !== 'undefined' && !!this.options.translations.sell ? this.options.translations.sell : 'Vendita';
    toSellControlUI.innerHTML = typeof this.options.translations !== 'undefined' && !!this.options.translations.sell ? this.options.translations.sell : 'Vendita';
    toSellControlDiv.appendChild(toSellControlUI);

    toSellControlUI.addEventListener('click', (function() {
      this.filter = 'to_sell';
      this.showOnlyMarkerByType(this.filter);
      toSellControlUI.style.fontWeight = styles.selected.fontWeight;
      toSellControlUI.style.backgroundColor = styles.selected.backgroundColor;
      toSellControlUI.style.color = styles.selected.color;
      toSellControlUI.style.padding = '0px 17px';
      shortRentControlUI.style.fontWeight = styles.normal.fontWeight;
      shortRentControlUI.style.backgroundColor = styles.normal.backgroundColor;
      shortRentControlUI.style.color = styles.normal.color;
      if(!!this.map.infoBox) {
        this.map.infoBox.close();
      }
    }).bind(this));

    toSellControlUI.addEventListener('mouseover', () => {
      if(this.filter != 'to_sell') {
        toSellControlUI.style.backgroundColor = styles.hover.backgroundColor;
        toSellControlUI.style.color = styles.hover.color;
      }
    });

    toSellControlUI.addEventListener('mouseleave', () => {
      if(this.filter != 'to_sell') {
        toSellControlUI.style.backgroundColor = styles.normal.backgroundColor;
        toSellControlUI.style.color = styles.normal.color;
      }
    });

    toSellControlDiv.index = 1;
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(toSellControlDiv);

    var shortRentControlDiv = document.createElement('div');

    shortRentControlDiv.style.margin = '10px 10px 0 0';

    var shortRentControlUI = document.createElement('div');

    shortRentControlUI.style.cursor = 'pointer';
    shortRentControlUI.style.direction = 'ltr';
    shortRentControlUI.style.overflow = 'hidden';
    shortRentControlUI.style.textAlign = 'center';
    shortRentControlUI.style.height = '40px';
    shortRentControlUI.style.display = 'table-cell';
    shortRentControlUI.style.verticalAlign = 'middle';
    shortRentControlUI.style.position = 'relative';
    shortRentControlUI.style.color = styles.normal.color;
    shortRentControlUI.style.fontFamily = 'Roboto, Arial, sans-serif';
    shortRentControlUI.style.fontWeight = styles.normal.fontWeight;
    shortRentControlUI.style.userSelect = 'none';
    shortRentControlUI.style.fontSize = '15px';
    shortRentControlUI.style.textTransform = 'uppercase';
    shortRentControlUI.style.backgroundColor = styles.normal.backgroundColor;
    shortRentControlUI.style.padding = '0px 20px';
    shortRentControlUI.style.borderRadius = '0 2px 2px 0';
    shortRentControlUI.style.backgroundClip = 'padding-box';
    shortRentControlUI.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
    shortRentControlUI.style.minWidth = '66px';
    shortRentControlUI.style.borderLeft = '0px';

    shortRentControlUI.title = typeof this.options.translations !== 'undefined' && !!this.options.translations.rent ? this.options.translations.rent : 'Affitto';
    shortRentControlUI.innerHTML = typeof this.options.translations !== 'undefined' && !!this.options.translations.rent ? this.options.translations.rent : 'Affitto';
    shortRentControlDiv.appendChild(shortRentControlUI);

    shortRentControlUI.addEventListener('click', (function() {
      this.filter = 'short_rent';
      this.showOnlyMarkerByType(this.filter);
      shortRentControlUI.style.fontWeight = styles.selected.fontWeight;
      shortRentControlUI.style.backgroundColor = styles.selected.backgroundColor;
      shortRentControlUI.style.color = styles.selected.color;
      toSellControlUI.style.fontWeight = styles.normal.fontWeight;
      toSellControlUI.style.backgroundColor = styles.normal.backgroundColor;
      toSellControlUI.style.color = styles.normal.color;
      toSellControlUI.style.padding = '0px 18px';
      if(!!this.map.infoBox) {
        this.map.infoBox.close();
      }
    }).bind(this));

    shortRentControlUI.addEventListener('mouseover', () => {
      if(this.filter != 'short_rent') {
        shortRentControlUI.style.backgroundColor = styles.hover.backgroundColor;
        shortRentControlUI.style.color = styles.hover.color;
      }
    });

    shortRentControlUI.addEventListener('mouseleave', () => {
      if(this.filter != 'short_rent') {
        shortRentControlUI.style.backgroundColor = styles.normal.backgroundColor;
        shortRentControlUI.style.color = styles.normal.color;
      }
    });

    shortRentControlDiv.index = 1;
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(shortRentControlDiv);

    toSellControlUI.click();
  }

  placeMarkers() {
    if(this.options.markers) {
      this.options.markers.forEach((marker) => {
          this.placeMarker(marker);
      });
    }
  }

  placeMarker(marker_data) {
    var icon = null;

    if(marker_data.icon) {
        if(typeof marker_data.icon == 'string') {
            icon = {
                size: marker_data.iconSize ? marker_data.iconSize : this.options.iconSize,
                url: marker_data.icon,
            };
        } else {
            icon = marker_data.icon;
        }

        if(icon.size && icon.size instanceof Array && icon.size.length == 2) {
            icon.size = new google.maps.Size(icon.size[0], icon.size[1]);
        }

        if(icon.origin && icon.origin instanceof Array && icon.origin.length == 2) {
            icon.origin = new google.maps.Point(icon.origin[0], icon.origin[1]);
        }

        if(icon.anchor && icon.anchor instanceof Array && icon.anchor.length == 2) {
            icon.anchor = new google.maps.Point(icon.anchor[0], icon.anchor[1]);
        }

        if(icon.scaledSize && icon.scaledSize instanceof Array && icon.scaledSize.length == 2) {
            icon.scaledSize = new google.maps.Size(icon.scaledSize[0], icon.scaledSize[1]);
        }
    }

    var marker = new google.maps.Marker({
        icon: icon,
        position: new google.maps.LatLng(
          marker_data.position.lat,
          marker_data.position.lng
        ),
        zIndex: marker_data.zIndex ? marker_data.zIndex : 0,
        type: marker_data.type,
        title: marker_data.title,
        description: marker_data.description,
        link: marker_data.link,
        price: marker_data.price,
        rooms_count: marker_data.rooms_count,
        surface: marker_data.surface,
        bathrooms_count: marker_data.bathrooms_count,
        plans_number: marker_data.plans_number,
        map: this.map,
        images: marker_data.images,
        optimized: false,
    });

    if(this.options.infoBox) {
      google.maps.event.addListener(marker, 'click', (/*e*/) => {
        // console.log('title', marker.title, marker.getPosition(), marker.infoBox);

        var roomsLabel = typeof this.options.translations !== 'undefined' && !!this.options.translations.rooms ? this.options.translations.rooms : 'Locali';
        var surfaceLabel = typeof this.options.translations !== 'undefined' && !!this.options.translations.surface ? this.options.translations.surface : 'Superficie';
        var bathroomsLabel = typeof this.options.translations !== 'undefined' && !!this.options.translations.bathrooms ? this.options.translations.bathrooms : 'Bagni';
        var floorLabel = typeof this.options.translations !== 'undefined' && !!this.options.translations.floor ? this.options.translations.floor : 'Piano';

        var content = '';

        content += '<a href="'+marker.link+'" style="text-decoration: none; color: inherit;">'
          content += '<div class="blocks-home-in-evidence">';
            content += '<div class="block-home-in-evidence">';
              content += '<div class="swiper-container">';
                content += '<div class="swiper-wrapper">';
                if(marker.images) {
                  marker.images.forEach(function(image) {
                    content += '<div class="swiper-slide" style="background-image:url(' + image + '"></div>';
                  });
                }
                content += '</div>';
                content += '<div class="swiper-button-next"></div>';
                content += '<div class="swiper-button-prev"></div>';
              content += '</div>';
              content += '<div class="container-features">';
                content += '<div class="row-features">';
                if(marker.rooms_count) {
                  content += '<div class="home-feature home-feature-rooms">';
                    content += '<span class="feature-value">' + marker.rooms_count + '</span>';
                    content += '<span class="feature-label">' + roomsLabel + '</span>';
                  content += '</div>';
                }
                if(marker.surface) {
                  content += '<div class="home-feature home-feature-surface">';
                    content += '<span class="feature-value">' + marker.surface + '</span>';
                    content += '<span class="feature-label">' + surfaceLabel + '</span>';
                  content += '</div>';
                }
                if(marker.bathrooms_count) {
                  content += '<div class="home-feature home-feature-bathrooms">';
                    content += '<span class="feature-value">' + marker.bathrooms_count + '</span>';
                    content += '<span class="feature-label">' + bathroomsLabel + '</span>';
                  content += '</div>';
                }
                if(marker.plans_number) {
                  content += '<div class="home-feature home-feature-plans">';
                    content += '<span class="feature-value">' + marker.plans_number + '</span>';
                    content += '<span class="feature-label">' + floorLabel + '</span>';
                  content += '</div>';
                }
                content += '</div>';
                content += '<div class="home-title">' + marker.title + '</div>';
                content += '<div class="home-price">' + marker.price + '</div>';
                content += '<div class="home-description">' + marker.description + '</div>';
              content += '</div>';
            content += '</div>';          
          content += '</div>';
        content += '</a>';

        this.map.infoBox.setOptions({
          title: marker.title,
          content: content,
          link: marker.link,
          price: marker.price,
          rooms_count: marker.rooms_count,
          surface: marker.surface,
          bathrooms_count: marker.bathrooms_count,
          plans_number: marker.plans_number,
          images: marker.images,
          position: marker.getPosition(),
          // iconHeight: marker.getIcon().size.height,
        });

        this.map.infoBox.open(this.map);

        setTimeout(function() {
          new Swiper('#map-container .swiper-container', {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            simulateTouch: false,
          });
        }, 100);
      });
    }

    this.markers.push(marker);
  }

  showOnlyMarkerByType(type) {
    if(!!this.markers && this.markers.length > 0) {
      this.markers.map((marker) => {
        if(!marker.type || marker.type != type) {
          marker.setVisible(false);
        } else {
          marker.setVisible(true);
        }
      });

      if(!!this.clusterer) {
        this.clusterer.resetViewport();
        this.clusterer.redraw();
      }
    }
  }

}

window.HFMap = HFMap;


// WEBPACK FOOTER //
// ./scripts/components/map.js